import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Header from './Header';
import Body from './Body';
import './styles.css';

class WindowLayout extends Component {
	render() {
		const { children } = this.props;
		return <div className="window-layout">{children}</div>;
	}
}
WindowLayout.propTypes = {
	children: PropTypes.node
};

Object.assign(WindowLayout, {
	Header,
	Body
});

export default WindowLayout;
